export const SELLER_FIELDS = [
  "sellerCompanyName",
  "sellerPersonalIdentificationNumber",
  "sellerHeadquartersAddress",
  "sellerSalesPersonName",
  "sellerPhoneNumber",
  "sellerTransactionAccountNumber",
] as const;
